import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor() {}

  getAuthToken(apiUrl) {
    if(apiUrl.indexOf("admin") > -1){
      return localStorage.getItem('Admin-Access-Token');
    }else if (apiUrl.indexOf("bots") > -1 || apiUrl.indexOf("templates") > -1 ||  apiUrl.indexOf("mini-apps") > -1 || apiUrl.indexOf("custom-codes") > -1) {
      return localStorage.getItem('apiKey');
    } else{
      return localStorage.getItem('Access-Token');
    }
  }

 saveUserInfo() {
    const token = localStorage.getItem('Access-Token');
    let payload;
    if (token) {
      payload = token.split(".")[1];
      payload = window.atob(payload);
      localStorage.setItem('loginUserDetails',payload);
      
    } 
  }

  saveAdminInfo() {
    const token = localStorage.getItem('Admin-Access-Token');
    let payload;
    if (token) {
      payload = token.split(".")[1];
      payload = window.atob(payload);
      localStorage.setItem('loginAdminDetails',payload);
      
    } 
  }
  
}
